import React from "react";

const FooterBlurb = () => (
  <section className="col-md-3 col-sm-6">
    <p>
      Secure Web Solutions LLC is a freelance consultancy focused on delivering
      innovative, secure, high-impact solutions with a focus on ROI.
    </p>
  </section>
);

export default FooterBlurb;
